'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { Box, Stack } from '@repo/panda/jsx';
import type { MiniMapCtaVariant } from '@repo/types/analytic-events/maps-analytic-events';
import cardBackground from '../../assets/mini-map-cta-card-bg.webp';
interface MiniMapCtaCardProps {
  isLaunchSuccessful: boolean;
  isLaunching: boolean;
  titleName?: string;
  trainerConnected: boolean;
  variant: MiniMapCtaVariant;
  onClose: () => void;
  onLaunch: () => void;
}
export function MiniMapCtaCard(t0) {
  const $ = _c(44);
  const {
    isLaunchSuccessful,
    isLaunching,
    titleName,
    trainerConnected,
    variant,
    onClose,
    onLaunch
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      position: "relative",
      width: "[340px]",
      maxWidth: "[calc(100vw - 112px)]",
      overflow: "hidden",
      borderRadius: "32",
      backgroundColor: "[rgba(0, 0, 0, 0.8)]",
      backdropFilter: "[blur(16px)]",
      boxShadow: "lg"
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = css({
      position: "absolute",
      top: "20",
      right: "20",
      zIndex: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "[32px]",
      height: "[32px]",
      padding: "4",
      borderWidth: "0",
      borderRadius: "full",
      backgroundColor: "white",
      color: "black",
      cursor: "pointer",
      filter: "[drop-shadow(0 1px 0 rgba(0, 0, 0, 0.3))]",
      _hover: {
        backgroundColor: "grey.100"
      },
      _focusVisible: {
        outline: "[2px solid token(colors.brand.primary)]",
        outlineOffset: "2"
      }
    });
    t5 = <Icon icon="close" size="sm" decorative={true} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isLaunching || $[7] !== onClose || $[8] !== t3) {
    t6 = <button type="button" aria-label={t3} onClick={onClose} disabled={isLaunching} className={t4}>{t5}</button>;
    $[6] = isLaunching;
    $[7] = onClose;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Box height="[140px]" marginBottom="[-24px]" overflow="hidden" position="relative"><img src={cardBackground.src} alt="" aria-hidden="true" className={css({
        position: "absolute",
        inset: "0",
        width: "full",
        height: "full",
        objectFit: "cover"
      })} /></Box>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = css({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "[48px]",
      height: "[48px]",
      borderRadius: "full",
      backgroundColor: "brand.primary"
    });
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Box className={t8}><Icon icon="radar" size="lg" fill={true} decorative={true} className={css({
        color: "black"
      })} /></Box>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t) {
    t10 = t(_temp2);
    $[13] = t;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = <Type variant="header-m" color="white">{t10}</Type>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t || $[18] !== trainerConnected || $[19] !== variant) {
    t12 = trainerConnected && variant === "a" ? t(_temp3) : t(_temp4);
    $[17] = t;
    $[18] = trainerConnected;
    $[19] = variant;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <Type variant="body-s" color="text.primary">{t12}</Type>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <Stack gap="8" paddingX="20" paddingBottom="[28px]" marginBottom="[-24px]" position="relative" zIndex="1">{t9}<Stack gap="8">{t11}{t13}</Stack></Stack>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== isLaunchSuccessful || $[27] !== isLaunching || $[28] !== onLaunch || $[29] !== t || $[30] !== trainerConnected) {
    t15 = isLaunchSuccessful ? <Button aria-live="polite" variant="filled" color="brand" size="lg" fullWidth={true} disabled={true} className={css({
      _disabled: {
        opacity: "1"
      }
    })}><Icon icon="check" decorative={true} />{t(_temp5)}</Button> : <Button onClick={onLaunch} variant="filled" color="brand" size="lg" fullWidth={true} disabled={isLaunching || !trainerConnected} className={css({
      opacity: !trainerConnected ? "[0.5]" : undefined
    })}>{isLaunching ? t(_temp6) : t(_temp7)}</Button>;
    $[26] = isLaunchSuccessful;
    $[27] = isLaunching;
    $[28] = onLaunch;
    $[29] = t;
    $[30] = trainerConnected;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== isLaunchSuccessful || $[33] !== t || $[34] !== titleName || $[35] !== trainerConnected) {
    t16 = !isLaunchSuccessful && !trainerConnected && <Type variant="body-xs" color="text.primary" textAlign="center">{t(_temp8, {
        titleName
      })}</Type>;
    $[32] = isLaunchSuccessful;
    $[33] = t;
    $[34] = titleName;
    $[35] = trainerConnected;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t15 || $[38] !== t16) {
    t17 = <Stack gap="6" paddingX="20" paddingTop="16" paddingBottom="20">{t15}{t16}</Stack>;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t14 || $[41] !== t17 || $[42] !== t6) {
    t18 = <Stack gap="0" className={t2}>{t6}{t7}{t14}{t17}</Stack>;
    $[40] = t14;
    $[41] = t17;
    $[42] = t6;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}
function _temp8($_6) {
  return $_6.mini_map_cta.launch_instruction;
}
function _temp7($_5) {
  return $_5.mini_map_cta.launch;
}
function _temp6($_4) {
  return $_4.mini_map_cta.launching;
}
function _temp5($_3) {
  return $_3.mini_map_cta.launch_success;
}
function _temp4($_2) {
  return $_2.mini_map_cta.variant_b_body;
}
function _temp3($_1) {
  return $_1.mini_map_cta.variant_a_body;
}
function _temp2($_0) {
  return $_0.mini_map_cta.title;
}
function _temp($) {
  return $.mini_map_cta.close_aria_label;
}